import { apiSlice } from "../../app/api/apiSlice";

export const fetchEnhancedConditionsEfolderDocumentsListApiSlice =
	apiSlice.injectEndpoints({
		endpoints: (builder) => ({
			enhancedConditionsEfolderDocumentsList: builder.mutation({
				query: (credentials) => ({
					url: `api/v1/loan/get_enhanced_conditions_efolder_attachments_list/${credentials.loanGuid}`,
					method: "GET",
				}),
			}),
		}),
	});

export const { useEnhancedConditionsEfolderDocumentsListMutation } =
	fetchEnhancedConditionsEfolderDocumentsListApiSlice;
